import { useState } from 'react';
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Tab,
  Tabs,
  TextField,
} from '@mui/material';
import { a11yProps, TabPanel } from '../language-tabs';
import { DEFAULT_LANGUAGES } from '../../config/quill-text-editor-settings';

// ----------------------------------------------------------------------
const defaultState = {
  title_en: '',
  title_fr: '',
};

export default function PickemDialog(props: any) {
  const [pickem, setPickem] = useState(defaultState);

  const handleChange = (e: any) => {
    const { id, value } = e.target;

    setPickem((prevState) => ({
      ...prevState,
      [id]: value,
    }));
  };

  const [value, setValue] = useState(0);

  const handleChangeTabs = (_event: any, newValue: number) => {
    setValue(newValue);
  };

  const onSuccess = () => {
    setPickem(defaultState);
    props.onSuccessHandler(pickem);
  };

  const onCancel = () => {
    setPickem(defaultState);
    props.onClose();
  };

  return (
    <>
      <Dialog
        open={props.open}
        onClose={() => {}}
        aria-labelledby='alert-dialog-title'
        aria-describedby='alert-dialog-description'
      >
        <DialogTitle id='alert-dialog-title'>Create Pickem</DialogTitle>
        <DialogContent>
          <Box sx={{ width: '100%' }}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
              <Tabs
                value={value}
                onChange={handleChangeTabs}
                aria-label='basic tabs example'
              >
                {DEFAULT_LANGUAGES.map((lang, index) => (
                  <Tab
                    key={lang.code}
                    label={lang.label}
                    {...a11yProps(index)}
                  />
                ))}
              </Tabs>
            </Box>

            {DEFAULT_LANGUAGES.map((lang, index) => (
              <TabPanel key={lang.code} value={value} index={index}>
                <TextField
                  id={`title_${lang.code}`}
                  label={`Title ${lang.label}`}
                  fullWidth
                  value={(pickem as any)[`title_${lang.code}`]}
                  variant='standard'
                  onChange={handleChange}
                />
              </TabPanel>
            ))}
          </Box>
          <Box sx={{ width: '100%' }}></Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => onCancel()}>Cancel</Button>
          <Button onClick={() => onSuccess()} autoFocus>
            Create
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
